var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2392_11423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.25C4.5 9.83516 4.16484 9.5 3.75 9.5C3.33516 9.5 3 9.83516 3 10.25V11.75C3 12.9922 4.00781 14 5.25 14H11.25C12.4922 14 13.5 12.9922 13.5 11.75V10.25C13.5 9.83516 13.1648 9.5 12.75 9.5C12.3352 9.5 12 9.83516 12 10.25V11.75C12 12.1648 11.6648 12.5 11.25 12.5H5.25C4.83516 12.5 4.5 12.1648 4.5 11.75V10.25Z",
    fill: "#00F9A9",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71777 10.0303C8.01074 10.3232 8.48652 10.3232 8.77949 10.0303H8.78184L11.7818 7.03027C12.0748 6.7373 12.0748 6.26152 11.7818 5.96855C11.4889 5.67559 11.0131 5.67559 10.7201 5.96855L8.9998 7.68887V2.75059C8.9998 2.33574 8.66465 2.00059 8.2498 2.00059C7.83496 2.00059 7.4998 2.33574 7.4998 2.75059V7.68887L5.77949 5.96855C5.48652 5.67559 5.01074 5.67559 4.71777 5.96855C4.4248 6.26152 4.4248 6.7373 4.71777 7.03027L7.71777 10.0303Z",
    fill: "#00F9A9",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2392_11423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 12,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame12);
export default __webpack_public_path__ + "static/media/frame12.d4d1949d57a29e03a568c2d9a260302f.svg";
export { ForwardRef as ReactComponent };